(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gezu-pdp-trust-horizontal"] && !Shopify.designMode) return;
  try {
    (function(){
    if (window.__gzPdpTrust) return;
    window.__gzPdpTrust = true;

    function closeAll(){
      document.querySelectorAll('[data-gz-modal]:not([hidden])').forEach(function(m){ m.hidden = true; });
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function(e){
      var opener = e.target.closest('[data-gz-open]');
      if (opener){
        var root = opener.closest('[data-gz-pdp]');
        var m = root && root.querySelector('[data-gz-modal="' + opener.getAttribute('data-gz-open') + '"]');
        if (m){
          m.hidden = false;
          document.body.style.overflow = 'hidden';
          var f = m.querySelector('input, a, button:not([data-gz-close])');
          if (f){ try { f.focus(); } catch(err){} }
        }
        return;
      }
      var closer = e.target.closest('[data-gz-close]');
      if (closer){
        var mm = closer.closest('[data-gz-modal]');
        if (mm){ mm.hidden = true; document.body.style.overflow = ''; }
      }
    });

    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeAll(); });
  })();
  } catch(e) { console.error(e); }
})();

})();
